import React, { useRef, useMemo, useCallback, useEffect } from "react";
import { Form, InputNumber } from "antd";
import { connect } from "dva";

const DealerVariable = ({ configPerm, inherited, strategy, onChange }) => {
  const variableFormRef = useRef(null);
  const lastRegisteredMarginValue = useRef(null);

  const disabled = useMemo(
    () => !configPerm["PricingService.PricingSettings.Update"] || inherited,
    [inherited, configPerm],
  );

  const handleMarginChange = useCallback(
    newMargin => {
      if (typeof onChange === "function") {
        onChange({ margin: newMargin });
      }
    },
    [onChange],
  );

  useEffect(() => {
    if (!variableFormRef.current) {
      return;
    }

    if (typeof strategy?.margin === "number" && strategy.margin !== lastRegisteredMarginValue.current) {
      lastRegisteredMarginValue.current = strategy.margin;
      variableFormRef.current.setFieldsValue({
        margin: strategy.margin,
      });
    }
  }, [strategy?.margin]);

  return (
    <Form layout="vertical" ref={variableFormRef}>
      <Form.Item label="Margin" name="margin">
        <InputNumber
          min={1}
          max={100}
          formatter={value => `${value}%`}
          parser={value => (value ? value.replace("%", "") : "")}
          disabled={disabled}
          onChange={handleMarginChange}
        />
      </Form.Item>
    </Form>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(DealerVariable);
